import { TypeParams } from "../../types";
import { useTranslation } from 'react-i18next';

interface EgwClientareaHomeProps {
  // commitCurrentPlace: (placeId: number | null) => void;
  params: TypeParams; // Define the type of the ccid prop
}

const EgwClientareaHome: React.FC<EgwClientareaHomeProps> = ({ params }) => {
  const { t } = useTranslation();

  return (
    <>
      <strong>{t("kundenbereich.home.welcome")}</strong>
      <p>{t("kundenbereich.home.intro")}</p>
    </>
  );
};

export default EgwClientareaHome;
